import {put,takeLatest,call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    GET_ALL_VENUES,
    GET_ALL_VENUES_SUCCESS,
    GET_ALL_VENUES_ERROR
}
    from "../../actions/venue";

function* getAllVenuesSaga(action) {
    try {
        const data=yield call(venueService.GetAllVenues,action.payload)
        yield put({
            type: GET_ALL_VENUES_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_ALL_VENUES_ERROR,error: error.data
        });
    }
}


export function* getAllVenuesSagaWatcher() {
    yield takeLatest(GET_ALL_VENUES,getAllVenuesSaga);
}